export const faqItems = [
  {
    question: "What is an acbuy spreadsheet and how does it work?",
    answer: "An acbuy spreadsheet is a regularly updated product sourcing document that contains verified supplier information, up-to-date pricing data, and organized product categories sourced from Chinese marketplaces. It works like a curated database — buyers browse through organized sheets to find products, compare supplier ratings, and make informed purchasing decisions without spending hours searching through raw marketplace listings. The spreadsheet is designed to simplify the entire sourcing workflow for international buyers who want efficient access to China-based products.",
  },
  {
    question: "Is the acbuy spreadsheet updated regularly?",
    answer: "Yes, the acbuy spreadsheet receives frequent updates to ensure pricing information, supplier details, and product availability remain accurate. The team behind the spreadsheet monitors marketplace changes, removes outdated listings, and adds new verified products on an ongoing basis. This regular maintenance is one of the key advantages over static product lists or one-time data dumps that quickly become obsolete in the fast-moving Chinese e-commerce landscape.",
  },
  {
    question: "How safe is it to use the acbuy spreadsheet for sourcing?",
    answer: "Using the acbuy spreadsheet is significantly safer than sourcing products directly from unverified marketplace listings. The spreadsheet includes only supplier-vetted entries, reducing the risk of encountering fraudulent sellers or misleading product descriptions. However, as with any international sourcing activity, buyers should still exercise due diligence — verify supplier credentials, start with small test orders, and use secure payment methods. The spreadsheet serves as a trusted starting point rather than a guarantee.",
  },
  {
    question: "What product categories are available in the acbuy spreadsheet?",
    answer: "The acbuy spreadsheet covers a wide range of product categories including Shoes, Hoodies and Sweaters, T-Shirts, Jackets, Pants and Shorts, Headwear, Matching Sets, Underwear, Jerseys, Accessories, Bags, Belts, Perfumes, and many more. Each category is organized with detailed product information, supplier contacts, and current pricing to help buyers quickly locate exactly what they are looking for.",
  },
  {
    question: "How does the acbuy spreadsheet compare to using Taobao agents?",
    answer: "The acbuy spreadsheet offers several advantages over traditional Taobao agents: it provides direct access to organized product data without agent markup fees, allows buyers to browse multiple categories simultaneously, and updates pricing information more frequently. While agents can offer personalized shopping services, the spreadsheet gives buyers more control over their sourcing process and typically results in lower overall costs. Many experienced buyers use both tools complementarily — the spreadsheet for research and discovery, agents for complex logistics.",
  },
  {
    question: "Can beginners use the acbuy spreadsheet effectively?",
    answer: "Absolutely. The acbuy spreadsheet is designed to be beginner-friendly with clearly labeled categories, straightforward product descriptions, and easy-to-navigate organization. New buyers can start by browsing popular categories, comparing prices, and placing small test orders to build confidence. The spreadsheet eliminates much of the complexity associated with Chinese marketplace navigation, language barriers, and supplier verification — making it one of the most accessible entry points for anyone new to product sourcing from China.",
  },
];

export const features = [
  {
    icon: "ri-flashlight-line",
    title: "Faster Sourcing",
    description: "Skip hours of marketplace browsing. The acbuy spreadsheet compiles verified products into one organized document, cutting research time dramatically.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Lower Product Costs",
    description: "Access direct supplier pricing without agent markups. Compare across categories to find the best value for every product type.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Verified Suppliers",
    description: "Every supplier listed in the acbuy spreadsheet undergoes verification checks, reducing the risk of scams and low-quality products.",
  },
  {
    icon: "ri-stack-line",
    title: "Bulk Buying Efficiency",
    description: "The spreadsheet format makes it easy to plan bulk orders across multiple categories, consolidating your sourcing into fewer shipments.",
  },
];

export const comparisonData = [
  {
    feature: "Data Update Frequency",
    acbuy: "Regular (Weekly+)",
    traditional: "Manual / One-time",
  },
  {
    feature: "Supplier Verification",
    acbuy: "Pre-vetted",
    traditional: "Self-verified",
  },
  {
    feature: "Price Transparency",
    acbuy: "Direct Listing Prices",
    traditional: "Agent Markup Added",
  },
  {
    feature: "Category Coverage",
    acbuy: "14+ Categories",
    traditional: "Fragmented per Agent",
  },
  {
    feature: "Learning Curve",
    acbuy: "Beginner Friendly",
    traditional: "Steep",
  },
  {
    feature: "Risk Level",
    acbuy: "Lower",
    traditional: "Medium to High",
  },
];